import type { CMYKColor } from "../types/colors/CMYKColor"
import type { RGBColor } from "../types/colors/RGBColor"

/**
 * Converts CMYK color to RGB color
 * Assumes CMYK values are in range 0-1
 */
export function CmykToRgb(cmyk: CMYKColor): RGBColor {
  const { c, m, y, k, a } = cmyk

  // Convert CMYK to RGB
  const r = (1 - c) * (1 - k)
  const g = (1 - m) * (1 - k)
  const b = (1 - y) * (1 - k)

  return { r, g, b, a }
}
